import * as Sentry from "@sentry/react";
import { version } from "../../../package.json";
import * as AuthenticationUtils from "../Utils/AuthenticationUtils";

import LogService from "./LogService";

const LOG_TAG = "SERVICE:SENTRY";
const SENTRY_ATTACHMENT_MAX_SIZE = 20480000; //20MB

export const Env = {
    Production: "production",
    Staging: "staging",
    Development: "development"
}

export const initializeSentry = () => {
    const environment = getEnvironment();
    // if (environment !== Env.Development)
    Sentry.init({
        dsn: "https://32afaad965d24a6aad8dfadc7ed256a3@sentry.openrainbow.io/63",
        environment: environment,
        release: version,
        beforeSend: async (event, hint) => {
            if (event.exception) {
                //todo add popup for ask user
                LogService.error(LOG_TAG, "Sentry send error.Eventid:", event.event_id, "exception:", hint.originalException.message);
                let content = await readLogFiles();
                LogService.info(LOG_TAG, "initializeSentry beforeSend attachment size", content?.length);
                if (content?.length < SENTRY_ATTACHMENT_MAX_SIZE)
                    hint.attachments = [{ filename: "log.zip", data: content }];// data: string or Uint8Array
                else {
                    LogService.warn(LOG_TAG, "initializeSentry beforeSend skip attachment because file too large",);
                    event.fingerprint = ["attachment file too large"];
                }
            }
            return event;
        },
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        // tracesSampleRate: 1.0,
    });
}

export const getEnvironment = () => {
    let sentryEnvironment = Env.Development;

    const hostname = window.location.hostname;

    if (hostname === "localhost") {
        sentryEnvironment = Env.Development;
    } else if (AuthenticationUtils.isPointComServer(hostname) ||
        AuthenticationUtils.isPointComCnServer(hostname) ||
        AuthenticationUtils.isPointHealthServer(hostname) ||
        AuthenticationUtils.isMonacoServer(hostname)) {
        sentryEnvironment = Env.Production;
    } else if (AuthenticationUtils.isPointNetServer(hostname) ||
        AuthenticationUtils.isPointOrgServer(hostname)) {
        sentryEnvironment = Env.Staging;
    }

    LogService.info(LOG_TAG, "getEnvironment", sentryEnvironment);
    return sentryEnvironment;
}

const readLogFiles = () => {
    return LogService.getLogFiles().then((blobContent) => {
        LogService.info(LOG_TAG, "readLogFiles got log file");
        return blobContent.arrayBuffer().then(data => {
            return new Uint8Array(data);
        });
    });
}

export const trackError = (error, errorInfo) => {
    LogService.info(LOG_TAG, "trackError");

    try {
        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });

        LogService.info(LOG_TAG, "trackError success");
    } catch (err) {
        LogService.error(LOG_TAG, "trackError failed", err);
    }
}